import { TypeService, ViewService } from '@sol/components';
import { WebContentAnnotationType } from '../models/web-content-annotation-type';
import { WebContentNotesViewId } from '../models/web-content-notes-view-id';

export function provideWebContentV2Views(viewService: ViewService, typeService: TypeService): void {
  typeService.addType(WebContentAnnotationType.annotation);
  viewService.addView(
    WebContentAnnotationType.annotation.array,
    'read',
    WebContentNotesViewId.notes,
    () =>
      import('../components/web-content-notes-view/web-content-notes-view.component').then(
        m => m.WebContentNotesViewComponent,
      ),
    true,
  );
}
